import { fetch } from './request';
export const autoFillFrom = async (
  params: { autoFillData: any },
): Promise<{ uuid: string } | Error> => {
  const { autoFillData } = params;
  return await fetch
    .post('/form/v1/auto_fill_data', { auto_fill_data: JSON.stringify(autoFillData), use_num_limit: 100, channel: 'livechat' })
    .then((res: any) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getFormSchema = async (params: {
  form_sn: string;
}): Promise<
| {
  form_schema: string;
  ui_schema: string;
  help_email: string;
  name: string;
  login_type: number;
  session_id: string;
  description: string;
}
| Error
> => {
  const { form_sn } = params;
  return await fetch
    .get(`/form/v1/forms/get?form_sn=${form_sn}`, { headers: { origin: window.location.origin } })
    .then((res: any) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const uploadInWebform = async (params: {
  file: any;
}): Promise<
| {
  file_name: string;
  url: string;
}
| Error
> => {
  const { file } = params;
  const formData = new FormData();
  formData.append('file', file);
  formData.append('biz_name', 'channel_form');
  return await fetch
    .post('/fileproxy/v2/files/toc', formData)
    .then((res: any) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};


// https://help.test.shopee.sg/api/inhouse/form/v1/forms/get?form_sn=c46c8910b6c24f44bed76e06803613ff
